export enum AuthenticationType {
  Unknown = 0,
  NeverAuthenticate = 1,
  AuthenticateViaActiveDirectory = 2,
  AuthenticateViaKronos = 3,
  S1Auth = 4,
}
export const getAuthenticationIcon = (authType: AuthenticationType): string => {
  switch (authType) {
    case AuthenticationType.AuthenticateViaActiveDirectory: 
      return "fa-windows fa-brands";
    case AuthenticationType.AuthenticateViaKronos:
      return "fa-clock";
    case AuthenticationType.S1Auth:
      return "fa-solid fa-sign-in";  
    case AuthenticationType.NeverAuthenticate:
      return "fa-ban";
    case AuthenticationType.Unknown:
    default:
      return "fa-question";
  }
} 